<template>
  <div v-bind:class="{animated: true, fadeIn: true, largerMobile: isMobileScreen}" >
    <br />
    <br />
    <div v-if="noTemplateUsed">
      <router-link to="/tutorial">
        <b-alert class="text-center" show variant="success">Ainda não entendeu? Clique aqui para ver o tutorial</b-alert>
      </router-link>
    </div>
    <div v-if="!isMine">
      <div class="card bg-info">
        <div class="card-body pb-0 center-text">
          <div class="float-right btn-group b-dropdown dropdown"></div>
          <h4 class="mb-0">Encontre o {{templateName}} ideal para você!</h4>
        <multiselect
          v-model="selectedCategories"
          @input="searchItems"
          class="background-multiSelect margin-extra"
          placeholder="Selecione uma categoria"
          label="name"
          track-by="_id"
          :options="categoriesList"
          :multiple="true"
          :taggable="true"
          :select-label="'Selecionar'"
          :deselect-label="'Remover'"
          :selected-label="'Selecionado'"
          :disabled="loading"
          @tag="addTag"
          tagPlaceholder="Confirme para buscar por palavra-chave"
        ></multiselect>
        <b-row class="text-left">
          <b-col sm="12" style="color: white; margin-left: 20px;">
            <b>Mais buscadas:</b>
          </b-col>
          <b-col sm="12" v-if="hotCategories && hotCategories.length">
            <a href="#" @click="() => { selectedCategories.push(category); searchItems(); }" v-for="(category, index) in hotCategories" :key="index">
              <b-badge show variant="success" style="background-color: white; color: #63c2de; max-width: 130px; margin-left: 15px; margin-top: 10px; padding: 10px;">
                <b>{{category.name}}</b>
              </b-badge>
            </a>
          </b-col>
        </b-row>
        <br />
        <b-row v-if="isAdmin" class="text-left">
          <b-col sm="12" style="color: white; margin-left: 20px;">
            <a href="#" @click="showColorFilter = !showColorFilter" style="color: white;"><b>Filtrar por cor <i class="fa fa-arrow-circle-down"></i></b></a>
          </b-col>
          <b-col v-show="showColorFilter" sm="12">
            <b-form-group>
              <b-form-checkbox-group
                id="checkbox-group-2"
                v-bind:true-value="1"
                v-bind:false-value="0"
                v-model="selected"
                @change="updateColors"
                name="flavour-2"
                style="margin-left: 20px;"
              >
                <b-form-checkbox v-for="(color, index) in colors" v-bind:key="index" v-bind:value="color.name">{{color.name}}</b-form-checkbox>
              </b-form-checkbox-group>
            </b-form-group>
          </b-col>
        </b-row>
        <br />
      </div>
      </div>
    </div>
    <div v-else>
      <div class="card bg-info" v-if="nothingAvailable == false || selectedCategories.length > 0">
        <div class="card-body pb-0 center-text">
          <div class="float-right btn-group b-dropdown dropdown"></div>
          <h4 class="mb-0">O {{templateName}} que você usou está aqui!</h4>
          <br />
          <br />
        </div>
        <multiselect
          v-model="selectedCategories"
          @input="getUserTemplates"
          class="background-multiSelect margin-extra"
          placeholder="Selecione uma categoria"
          label="name"
          track-by="_id"
          :options="categoriesList"
          :multiple="true"
          :taggable="true"
          :select-label="'Selecionar'"
          :deselect-label="'Remover'"
          :selected-label="'Selecionado'"
          @tag="addTag"
          tagPlaceholder="Confirme para buscar por palavra-chave"
        ></multiselect>
        <br />
      </div>
    </div>
    <spinner v-if="loading"></spinner>
    <b-card header-tag="header" v-if="loading == false">
      <div slot="header">
        <i class="icon-star"></i>
        {{isMine ? ("Meus " + templateName + "s") : (templateName + "s")}}
      </div>
      <b-card-body v-if="nothingAvailable && selectedCategories.length < 1 && isMine">
        <div class="card-body" v-if="nothingAvailable == true">
          <div>
            <div class="jumbotron">
              <h3>Os {{templateName}}s que você salvar estarão aqui!</h3>
            </div>
          </div>
        </div>
      </b-card-body>
      <b-card-body v-else-if="nothingAvailable && selectedCategories.length < 1 && isFavorites">
        <div class="card-body" v-if="nothingAvailable == true">
          <div>
            <div class="jumbotron">
              <h3>Use o coração embaixo dos posts para favoritá-los e vê-los aqui.</h3>
            </div>
          </div>
        </div>
      </b-card-body>
      <b-card-body v-else>
        <b-row v-if="!isMine && false">
          <b-col>
            <span class="badge badge-pill badge-primary"><i class="fa fa-heart-o text-center"></i></span> Clique no coração para salvar o Sleeker! Você consumirá um crédito para salvar, mas depois poderá usar sem limites da tela Meus Sleekers.
          </b-col>
        </b-row>
        <br/>
        <b-row v-if="nothingAvailable == false && loading == false">
          <design-box
            v-for="template in templatesList"
            v-bind:thumbnail="template.thumbnail"
            v-bind:templateId="template._id"
            v-bind:isStory="template.story"
            v-bind:freeUseAllowed="isFreeUseAllowed(template)"
            v-bind:advancedEdition="template.advancedEdition"
            v-bind:key="template._id"
            v-bind:isMine="isMine"
            v-bind:isAdmin="isAdmin"
            v-bind:isTester="(isAdmin || (me && me.subscription && me.subscription.planType == 'FREEPASS'))"
            v-bind:isFavorite="isFavorites"
            v-bind:customColorsVersion="template.hasColoredVersion2"
            v-bind:isVideo="template.videoPreview"
            v-bind:isCarousel="isCarousel(template)"
            v-bind:originalCarouselTemplateId="template.originalCarouselTemplateId"
            v-bind:carouselEditionId="template.carouselEditionId"
            v-bind:selectedColorId="template.selectedColorId"
            v-bind:selectedCarouselLine="template.selectedCarouselLine"
            v-bind:customColorsCarousel="template.customColorsCarousel"
            v-bind:newCarouselScreen="(isAdmin || me && me.tester) && isMobileScreen"
            :hasFamily="template.family"
            v-on:favoriteDeleted="refreshData"
            color="bg-secondary"
          >
            <h6></h6>
          </design-box>
        </b-row>
        <div class="center" v-if="nothingAvailable == false && loading == false">
          <div class="overflow-auto">
            <div class="mt-3">
              <b-pagination
                v-if="nothingAvailable == false"
                :total-rows="totalPages * perPage"
                :per-page="perPage"
                v-model="currentPage"
                v-on:input="startList"
                align="center"
                prev-text="Anterior"
                next-text="Próxima"
              ></b-pagination>
            </div>
          </div>
        </div>
        <div class="card-body" v-if="nothingAvailable == true && selectedCategories.length > 0">
          <div>
            <div class="jumbotron">
              <h6 class="display-4">Tente usando outros filtros</h6>
              <p class="lead">Não foi possível encontrar templates com essa combinação de categorias</p>
            </div>
          </div>
        </div>
      </b-card-body>
    </b-card>
  </div>
</template>

<script>
import DesignBox from "./theme/DesignBox";
import service from "./../service";
import VueBootstrapTypeahead from "vue-bootstrap-typeahead";
import Multiselect from "vue-multiselect";
import { constants } from "fs";
import { isMobile } from "mobile-device-detect";
import Spinner from "./Spinner";
import { isIOS } from "mobile-device-detect";

export default {
  name: "DesignSearch",
  props: {
    isMine: false,
    isFavorites: false
  },
  data: function() {
    return {
      currentPage: 1,
      perPage: 24,
      totalPages: 1,
      selectedCategories: [],
      taggingSelected: null,
      categoriesList: [],
      templatesList: [],
      nothingAvailable: false,
      includeExpress: true,
      includeAdvanced: true,
      loading: true,
      onlyIncludeAdvanced: false,
      modalShow: false,
      noTemplateUsed: false,
      searchId: "",
      isMobileScreen: isMobile,
      isIOS: isIOS,
      me: undefined,
      showColorFilter: false,
      selected: [],
      unselected: [],
      colors: [{ name: "Amarelo", selected: true },
        { name: "Vermelho", selected: true },
        { name: "Verde", selected: true },
        { name: "Azul", selected: true },
        { name: "Rosa", selected: true },
        { name: "Laranja", selected: true }],
      banner: {}
    };
  },
  computed: {
    templateName() {
      return localStorage.templateName;
    },
    isAdmin: function() {
      return localStorage.admin;
    },
    hotCategories() {
      let hotCategories = [];

      if (this.categoriesList && this.categoriesList.length) {
        for (let key in this.categoriesList) {
          if (this.categoriesList[key].hot) {
            hotCategories.push(this.categoriesList[key])
          }
        }
      }
      
      return hotCategories;
    },
    showBanner() {
      return this.me && this.me.subscription && (this.me.subscription.status == 1 || this.me.subscription.status == 3) && !this.me.subscription.isExpired;
    
      //return (this.me && this.me.showMentorshipBanner);
      //return false;
    }
  },
  created: function() {
    this.modalShow = true;
    service.getMe().then(me => {
      if (!me.subscription.editionCount) {
        this.noTemplateUsed = true;
      }

      this.me = me;
    });

    service.getBanner().then(result => {
      this.banner = result.banner
      console.log(this.banner);
    });

    if (this.$route.params.page) {
      this.currentPage = parseInt(this.$route.params.page);
    }

    if (this.$route.params.searchId) {
      this.searchId = this.$route.params.searchId;
    }
    this.startList(true);

    for (let key in this.colors) {
      this.selected.push(this.colors[key].name);
    }
  },
  methods: {
    appBannerAction() {
      let url = "https://play.google.com/store/apps/details?id=pt.sleeker.androidapp";

      if (this.isIOS) {
        url = "https://apps.apple.com/us/app/sleeker/id1515716574"
      }

      window.open(url, "_blank");
    },
    bannerAction() {
      if (this.banner.destinationType == 0) {
        this.$router.push(this.banner.destination);
      } else {
        window.open(this.banner.destination, "_blank");
      }
    },
    isCarousel(template) {
      if ((template.categories && template.categories.length && template.categories.indexOf("5f751e1735ae013d26a03e38") >= 0) || template.story) {
        return true;
      }
      return false;
    },
    updateColors() {
      setTimeout(this.searchItems, 100);
    },
    startList(loadCategories) {
      if (this.$route.params.page != this.currentPage) {
        this.$router.push({ name: this.$route.name, params: { page: this.currentPage}});
        //this.$router.push({ name: 'Busca', params: { page: this.currentPage, searchId: this.searchId, isFavorites: this.isFavorites, isMine: this.isMine }});
      }
      
      if (!this.isMine) {
        //load only user Categories

        if (loadCategories) {
          service.getAllCategories().then(
            response => {
              this.categoriesList = response;
            },
            () => {
              this.showError = true;
            }
          );
        }
        
        this.getAllTemplates();
      } else {
        if (loadCategories) {
          service.getUserCategories().then(
            response => {
              this.categoriesList = response;
            },
            () => {
              this.showError = true;
            }
          );
        }
        this.getUserTemplates();
      }
    },
    isFreeUseAllowed(template) {
      if (template.freeUseAllowed && this.me && (this.me.subscription.status == 0 || this.me.subscription.status == 2)) {
        return true;
      } else if (template.freeVIPUseAllowed && this.me && this.me.vip) {
        return true;
      } else if (template.freePremiumUseAllowed && this.me && (this.me.subscription.status == 1 || this.me.subscription.status == 3)) {
        return true;
      }
      return 
    },
    showModal() {
      this.showModal = true;
    },
    hideModal() {
      this.$refs["bv-modal-example"].hide();
    },
    toggleModal() {
      // We pass the ID of the button that we want to return focus to
      // when the modal has hidden
      this.$refs["bv-modal-example"].toggle("#toggle-btn");
    },
    searchItems: function(){
      this.searchId = "";
      this.currentPage = 1;
      this.getAllTemplates();
    },
    searchTemplates: function(selectedItems) {
      if (this.onlyIncludeAdvanced) {
        this.includeExpress = 0;
        this.includeAdvanced = 1;
      } else {
        this.includeExpress = 1;
        this.includeAdvanced = 1;
      }

      if (this.isMine) {
        this.getUserTemplates();
        return;
      } else if (this.isFavorites) {
        this.getFavoriteTemplates();
        return;
      }

      let idList = [];
      let userCreatedSearches = [];

      if (selectedItems && selectedItems.length) {
        selectedItems.forEach(item => {
          if (selectedItems && selectedItems.length) {
            selectedItems.forEach(item => {
              if (!item.userCreatedSearch) {
                if (idList.indexOf(item._id) < 0) {
                  idList.push(item._id);
                }
              } else {
                if (userCreatedSearches.indexOf(item.name) < 0) {
                  userCreatedSearches.push(item.name);
                }
              }
            });
          }
        });
      }

      this.idList = idList;

      this.loading = true;

      service
        .searchTemplates({
          idList: this.idList,
          userCreatedSearches: userCreatedSearches,
          currentPage: this.currentPage,
          expressEdition: this.includeExpress,
          advancedEdition: this.includeAdvanced,
          searchId: this.searchId,
          colors: this.selected
        })
        .then(
          response => {
            if (response.searchId) {
              this.searchId = response.searchId;

              if ((response.selectedCategories && response.selectedCategories.length) || (response.userCreatedSearches && response.userCreatedSearches.length)) {
                this.selectedCategories = [];
                if (response.selectedCategories && response.selectedCategories.length) {
                  this.selectedCategories = response.selectedCategories;
                }

                if (response.userCreatedSearches && response.userCreatedSearches.length) {
                  for (let key in response.userCreatedSearches) {
                    this.selectedCategories.push({
                      _id: new Date().getTime() + key,
                      name: response.userCreatedSearches[key],
                      userCreatedSearch: true
                    });
                  }
                }
              }
            }

            let params = { page: this.currentPage };

            if (this.searchId) {
              params.searchId = this.searchId;
              this.$router.push({ name: 'Busca', params: params});
            }

            this.loading = false;
            if (response.templates.length < 1 && (!response.extraTemplates || response.extraTemplates.length < 1)) {
              this.nothingAvailable = true;
              this.templatesList = [];
              //this.selectedCategories = [];
              return;
            }

            

            if (response.extraTemplates) {
              let mixedTemplates = [];
              let index = 0;

              while (true) {
                if (!response.extraTemplates[index] && !response.templates[index]) {
                  break;
                }

                if (response.templates[index]) {
                  mixedTemplates.push(response.templates[index]);
                } 

                if (response.extraTemplates[index]) {
                  mixedTemplates.push(response.extraTemplates[index]);
                } 

                index++;
              }

              this.templatesList = mixedTemplates;

            } else {
              this.templatesList = response.templates;
            }
            
            this.nothingAvailable = false;
            this.totalPages = response.totalPages;
          },
          () => {
            this.templatesList = [];
            this.showError = true;
            this.nothingAvailable = true;
            this.loading = false;
          }
        );
    },
    getAllTemplates: function() {

      if (this.onlyIncludeAdvanced) {
        this.includeExpress = false;
        this.includeAdvanced = true;
      } else {
        this.includeExpress = true;
        this.includeAdvanced = true;
      }

      this.loading = true;

      this.searchTemplates(this.selectedCategories);
    },
    getFavoriteTemplates: function() {
      let idList = [];

      if (!this.selectedCategories || this.selectedCategories.length < 1) {
      } else {
        this.selectedCategories.forEach(item => {
          idList.push(item._id);
        });
      }

      this.idList = idList;

      service
        .getFavoriteTemplates(
          this.idList,
          this.currentPage,
          this.includeExpress,
          this.includeAdvanced
        )
        .then(
          response => {
            if (
              response.templates == undefined ||
              response.templates.length < 1
            ) {
              
              this.nothingAvailable = true;
              this.templatesList = [];
              //this.selectedCategories = [];
              this.loading = false;
              return;
            }

           
            this.nothingAvailable = false;
            this.templatesList = response.templates;
            this.totalPages = response.totalPages;
            this.loading = false;
          },
          () => {
            this.showError = true;
          }
        );
    },
    getUserTemplates: function() {
      let idList = [];

      if (!this.selectedCategories || this.selectedCategories.length < 1) {
      } else {
        this.selectedCategories.forEach(item => {
          idList.push(item._id);
        });
      }

      this.idList = idList;

      service
        .getUserTemplates(
          this.idList,
          this.currentPage,
          this.includeExpress,
          this.includeAdvanced
        )
        .then(
          response => {
            if (
              response.templates == undefined ||
              response.templates.length < 1
            ) {
              
              this.nothingAvailable = true;
              this.templatesList = [];
              //this.selectedCategories = [];
              this.loading = false;
              return;
            }

           
            this.nothingAvailable = false;
            this.templatesList = response.templates;
            this.totalPages = response.totalPages;
            this.loading = false;
          },
          () => {
            this.showError = true;
          }
        );
    },
    getTemplates: function() {
      if (this.isMine) {
        this.getUserTemplates();
      } else {
        this.getAllTemplates();
      }
    },
    refreshData: function() {
      this.getTemplates();
    },
    addTag(newTag) {
      this.searchId = "";
      let tag = {
        _id: new Date().getTime(),
        name: newTag,
        userCreatedSearch: true
      }
      //this.categoriesList.push(tag);
      this.selectedCategories.push(tag);
      this.searchTemplates(this.selectedCategories);
    }
  },
  components: { DesignBox, VueBootstrapTypeahead, Multiselect, Spinner }
};
</script>

<style src="vue-multiselect/dist/vue-multiselect.min.css"></style>



<style lang="css" scoped>
.background-multiSelect >>> .multiselect__tag {
  background: #20a8d8 !important;
}
.center-text {
  text-align: center !important;
}
.margin-extra {
  margin: 20px !important;
  width: unset !important;
}

.largerMobile {
  width: 110%;
  margin-left: -5%;
}
</style>
